import React, { useMemo } from "react";
import { Banner } from "@bookingcom/bui-react";
import { Trans } from "@bookingcom/lingojs-react";
import { useSelector } from "react-redux";
import { getSearchSegments } from "../../../store/search/selectors.js";
import { QuestionMarkCircleIcon } from "@bookingcom/bui-assets-react/streamline";
import Frame from "../Frame/index.js";
const DestinationUkraineWarning = () => {
    const searchSegments = useSelector(getSearchSegments);
    const shouldShowAlert = useMemo(() => {
        return searchSegments.some((segment) => {
            return segment.to.some((to) => to.country === "UA") || segment.from.some((from) => from.country === "UA");
        });
    }, [searchSegments]);
    return shouldShowAlert ? (React.createElement(Frame, { mb: 4 },
        React.createElement(Banner, { title: React.createElement(Trans, { tag: "flights_ukraine_armed_conflict_banner_header" }), text: React.createElement(Trans, { tag: "flights_ukraine_armed_conflict_banner_para_1" }), startIcon: QuestionMarkCircleIcon, variant: "hint", dismissible: false }))) : null;
};
export default DestinationUkraineWarning;
